<template>
  <div>
    <div class="overlay"></div>
    <FloatingButtonMenu
      :menu="floatComponents"
      @select="floatMenuSelectHandler"
    />
    <v-dialog v-model="showMap" persistent width="900" height="600">
      <MapComponent
        :key="componentKey"
        v-if="showMap"
        @close="closeDialogHandler"
      />
    </v-dialog>
    <v-dialog v-model="showStaticInfo" persistent width="700">
      <InformationComp @close="closeDialogHandler" />
    </v-dialog>
    <v-layout row wrap>
      <v-flex xs12 md9 pt-0>
        <Tabs v-model="selectedTab" show-arrows id="select-block">
          <v-tab
            v-for="(item, index) in computedBlockList"
            :key="item.id"
            class="activeTab"
            :href="'#tab-' + index"
            @click="tabChange(item)"
          >
            <span class="primaryText--text">
              {{ item.text }}
            </span>
          </v-tab>
          <v-tabs-items>
            <v-tab-item
              v-for="(item, index) in computedBlockList"
              :key="item.id"
              centered
              :value="'tab-' + index"
            >
            </v-tab-item>
          </v-tabs-items>
        </Tabs>
      </v-flex>
      <v-flex xs12 md3 text-sm-right d-flex>
        <div class="note">
          *YTC: {{ $t("Yet To Compute") }} , *NA: {{ $t("Not Available") }}
        </div>
      </v-flex>

      <!-- POSITION 1 -->
      <v-flex xs12 md5>
        <Card
          class="table-card"
          v-if="selectedTabCompPosition.pos_1 == 'table'"
        >
          <TableComp :headers="headers" :tableData="tableData" />
        </Card>

        <AvailabilityComp
          v-else-if="selectedTabCompPosition.pos_1 == 'other_cards'"
          :widgetList="widgetList"
          :widgetData="widgetData"
          :metric="metric"
          :carbonFootprint="carbonFootprint"
          :cardDataSetLeft="cardDataSetLeft"
          :cardDataSetRight="cardDataSetRight"
          :selectedTabCompPosition="selectedTabCompPosition"
        />

        <Card
          class="map-card"
          v-else-if="selectedTabCompPosition.pos_1 == 'graph_left'"
        >
          <div class="text-xs-center pt-3 pb-3">{{ $t(left.title) }}</div>
          <v-divider class="custom-divider" />
          <div class="pa-3">
            <GlobalGraph
              class="graph"
              v-if="computedSeries['left'].length"
              graphID="1"
              :series="computedSeries['left']"
              popUpWidth="15vw"
              :xAxisData="xAxisData['left']"
              :yAxis="computedYAxis['left']"
              :title="{ text: $t(left.title), show: false }"
              :theme="theme"
            />
          </div>
        </Card>

        <Card
          class="map-card"
          v-else-if="selectedTabCompPosition.pos_1 == 'graph_right'"
        >
          <div class="text-xs-center pt-3 pb-3">{{ $t(right.title) }}</div>
          <v-divider class="custom-divider" />
          <div class="pa-3">
            <GlobalGraph
              class="graph d-flex align-content-center"
              v-if="computedSeries['right'].length"
              graphID="2"
              :series="computedSeries['right']"
              popUpWidth="15vw"
              :xAxisData="xAxisData['right']"
              :yAxis="computedYAxis['right']"
              :title="{ text: $t(right.title), show: false }"
              :theme="theme"
            />
          </div>
        </Card>
      </v-flex>
      <!-- Position 2 -->
      <v-flex xs12 md7>
        <Card
          class="table-card"
          v-if="selectedTabCompPosition.pos_2 == 'table'"
        >
          <TableComp :headers="headers" :tableData="tableData" />
        </Card>

        <AvailabilityComp
          v-else-if="selectedTabCompPosition.pos_2 == 'other_cards'"
          :widgetList="widgetList"
          :widgetData="widgetData"
          :metric="metric"
          :carbonFootprint="carbonFootprint"
          :cardDataSetLeft="cardDataSetLeft"
          :cardDataSetRight="cardDataSetRight"
          :selectedTabCompPosition="selectedTabCompPosition"
        />
        <Card
          class="map-card"
          v-else-if="selectedTabCompPosition.pos_2 == 'graph_left'"
        >
          <div class="text-xs-center pt-3 pb-3">{{ $t(left.title) }}</div>
          <v-divider class="custom-divider" />
          <div class="pa-3">
            <GlobalGraph
              class="graph"
              v-if="computedSeries['left'].length"
              graphID="1"
              :series="computedSeries['left']"
              popUpWidth="15vw"
              :xAxisData="xAxisData['left']"
              :yAxis="computedYAxis['left']"
              :title="{ text: $t(left.title), show: false }"
              :theme="theme"
            />
          </div>
        </Card>

        <Card
          class="map-card"
          v-else-if="selectedTabCompPosition.pos_2 == 'graph_right'"
        >
          <div class="text-xs-center pt-3 pb-3">{{ $t(right.title) }}</div>
          <v-divider class="custom-divider" />
          <div class="pa-3">
            <GlobalGraph
              class="graph"
              v-if="computedSeries['right'].length"
              graphID="2"
              :series="computedSeries['right']"
              popUpWidth="15vw"
              :xAxisData="xAxisData['right']"
              :yAxis="computedYAxis['right']"
              :title="{ text: $t(right.title), show: false }"
              :theme="theme"
            />
          </div>
        </Card>
      </v-flex>

      <!-- Position 3 -->
      <v-flex xs12 md5>
        <Card
          class="table-card"
          v-if="selectedTabCompPosition.pos_3 == 'table'"
        >
          <TableComp :headers="headers" :tableData="tableData" />
        </Card>
        <AvailabilityComp
          v-else-if="selectedTabCompPosition.pos_3 == 'other_cards'"
          :widgetList="widgetList"
          :widgetData="widgetData"
          :metric="metric"
          :carbonFootprint="carbonFootprint"
          :cardDataSetLeft="cardDataSetLeft"
          :cardDataSetRight="cardDataSetRight"
          :selectedTabCompPosition="selectedTabCompPosition"
        />
        <Card
          class="map-card"
          v-else-if="selectedTabCompPosition.pos_3 == 'graph_left'"
        >
          <div class="text-xs-center pt-3 pb-3">{{ $t(left.title) }}</div>
          <v-divider class="custom-divider" />
          <div class="pa-3">
            <GlobalGraph
              class="graph"
              v-if="computedSeries['left'].length"
              graphID="1"
              :series="computedSeries['left']"
              popUpWidth="15vw"
              :xAxisData="xAxisData['left']"
              :yAxis="computedYAxis['left']"
              :title="{ text: $t(left.title), show: false }"
              :theme="theme"
            />
          </div>
        </Card>

        <Card
          class="map-card"
          v-else-if="selectedTabCompPosition.pos_3 == 'graph_right'"
        >
          <div class="text-xs-center pt-3 pb-3">{{ $t(right.title) }}</div>
          <v-divider class="custom-divider" />
          <div class="pa-3">
            <GlobalGraph
              class="graph"
              v-if="computedSeries['right'].length"
              graphID="2"
              :series="computedSeries['right']"
              popUpWidth="15vw"
              :xAxisData="xAxisData['right']"
              :yAxis="computedYAxis['right']"
              :title="{ text: $t(right.title), show: false }"
              :theme="theme"
            />
          </div>
        </Card>
      </v-flex>

      <!-- Position 4 -->
      <v-flex xs12 md7 class="full">
        <Card
          class="table-card"
          v-if="selectedTabCompPosition.pos_4 == 'table'"
        >
          <TableComp :headers="headers" :tableData="tableData" />
        </Card>

        <AvailabilityComp
          v-else-if="selectedTabCompPosition.pos_4 == 'other_cards'"
          :widgetList="widgetList"
          :widgetData="widgetData"
          :metric="metric"
          :carbonFootprint="carbonFootprint"
          :cardDataSetLeft="cardDataSetLeft"
          :cardDataSetRight="cardDataSetRight"
          :selectedTabCompPosition="selectedTabCompPosition"
        />
        <Card
          class="map-card"
          v-else-if="selectedTabCompPosition.pos_4 == 'graph_left'"
        >
          <div class="text-xs-center pt-3 pb-3">{{ $t(left.title) }}</div>
          <v-divider class="custom-divider" />
          <div class="pa-3">
            <GlobalGraph
              class="graph"
              v-if="computedSeries['left'].length"
              graphID="1"
              :series="computedSeries['left']"
              popUpWidth="15vw"
              :xAxisData="xAxisData['left']"
              :yAxis="computedYAxis['left']"
              :title="{ text: $t(left.title), show: false }"
              :theme="theme"
            />
          </div>
        </Card>

        <Card
          class="map-card"
          v-else-if="selectedTabCompPosition.pos_4 == 'graph_right'"
        >
          <div class="text-xs-center pt-3 pb-3">{{ $t(right.title) }}</div>
          <v-divider class="custom-divider" />
          <div class="pa-3">
            <GlobalGraph
              class="graph"
              v-if="computedSeries['right'].length"
              graphID="2"
              :series="computedSeries['right']"
              popUpWidth="15vw"
              :xAxisData="xAxisData['right']"
              :yAxis="computedYAxis['right']"
              :title="{ text: $t(right.title), show: false }"
              :theme="theme"
            />
          </div>
        </Card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import _ from "lodash";
import CommonApi from "@/services/Common";
import PlantOverviewAPI from "@/services/PlantOverview";
import { mapGetters, mapMutations } from "vuex";
import { mapGettersMixin } from "@/util/mixin/index";
const FloatingButtonMenu = () =>
  import("@/components/common/FloatingButtonMenu");
const MapComponent = () =>
  import("@/components/Plant Overview New/MapComponent");
const TableComp = () => import("@/components/Plant Overview New/Table");

const AvailabilityComp = () =>
  import("@/components/Plant Overview New/AvailabilityComponent");
const InformationComp = () =>
  import("@/components/utility/InformationComponent");

const DataCardSet = () => import("@/components/Plant Overview New/DataCardSet");

const moment = require("moment");
const momentTz = require("moment-timezone");

export default {
  mixins: [mapGettersMixin],
  components: {
    FloatingButtonMenu,
    MapComponent,
    AvailabilityComp,
    InformationComp,
    TableComp,
    DataCardSet,
  },
  data() {
    return {
      componentKey: 0,
      widgetDataSet: [],
      showMap: false,
      showStaticInfo: false,
      selectedTab: "plant",
      tableData: [],
      todayco2Reduction: 0,
      co2Multiplier: 0.392,
      equiTreesMultiplier: 0.0117,
      cardDataSetLeft: [],
      cardDataSetRight: [],
      lifeTimeGeneration: 0,
      blockId: 1,
      blockList: [],
      series: {
        left: [],
        right: [],
      },
      xAxisData: {
        left: [],
        right: [],
      },
      yAxis: {
        left: [
          {
            type: "value",
            name: "",
            min: 0,
            position: "left",
            axisLabel: {
              formatter: "{value}",
              rotate: 40,
            },
          },
        ],
        right: [
          {
            type: "value",
            name: "",
            min: 0,
            position: "left",
            axisLabel: {
              formatter: "{value}",
              rotate: 40,
            },
          },
        ],
      },
      left: {
        isMap: false,
        title: "",
      },
      right: {
        isMap: false,
        title: "",
      },
      widgetList: [],
      instantaneousValue: [],
      positions: {},
    };
  },
  computed: {
    ...mapGetters([
      "getActivePlantTimezone",
      "getSelectedPlantId",
      "getRules",
    ]),
    getFloatingButton() {
      return (
        this.getRules(["rule", "comp_config"]).plant_overview &&
        this.getRules(["rule", "comp_config"]).plant_overview.options &&
        this.getRules(["rule", "comp_config"]).plant_overview.options
          .floating_button
      );
    },
    floatComponents() {
      const rule = _.cloneDeep(this.getRules(["rule", "access_config"]));
      if (rule) {
        const componentList = Object.values(rule).reduce((list, el) => {
          if (Array.isArray(el)) {
            return [...list, ...el];
          } else {
            return [...list, el];
          }
        }, []);
        const componentObj = componentList.find(
          (el) => el.path === `/${this.$route.path.split("/").slice(-1)[0]}`
        );
        return componentObj
          ? [
              ...this.getFloatingButton,
              {
                icon: "feed",
                name: "STATIC\nINFO",
                component: "static",
              },
            ] || []
          : [
              {
                icon: "feed",
                name: "STATIC\nINFO",
                component: "static",
              },
            ];
      }
      return [
        {
          icon: "feed",
          name: "STATIC\nINFO",
          component: "static",
        },
      ];
    },
    computedBlockList() {
      if (this.blockList.length > 0) {
        const cloneBlockList = _.cloneDeep(this.blockList);
        cloneBlockList[0].text = this.$t(cloneBlockList[0].text);
        return cloneBlockList;
      } else {
        return [];
      }
    },
    showFloat() {
      return (
        this.floatComponents !== undefined && !!this.floatComponents.length
      );
    },
    headers() {
      return [
        {
          text: this.$t("KPI Metrics"),
          align: "left",
          value: "name",
          width: "150px",
          sortable: false,
        },
        {
          text: this.$t("Today"),
          value: "today",
          align: "center",
          width: "90px",
          sortable: false,
        },
        {
          text: this.$t("Yesterday"),
          value: "yesterday",
          align: "center",
          width: "90px",
          sortable: false,
        },
        {
          text: this.$t("This month"),
          value: "month",
          align: "center",
          width: "90px",
          sortable: false,
        },
        {
          text: this.$t("This year"),
          value: "year",
          align: "center",
          width: "90px",
          sortable: false,
        },
      ];
    },
    computedSeries() {
      const series = _.cloneDeep(this.series);
      Object.keys(series).forEach((position) => {
        series[position].forEach((seriesObj) => {
          seriesObj.name = seriesObj.name.replace(
            seriesObj.parameterName,
            this.$t(seriesObj.parameterName)
          );
          seriesObj.name = seriesObj.name.replace(
            seriesObj.device,
            this.$t(seriesObj.device)
          );
        });
      });

      return series;
    },
    computedYAxis() {
      const yAxis = _.cloneDeep(this.yAxis);
      Object.keys(yAxis).forEach((position) => {
        yAxis[position].forEach((yAxisObj) => {
          yAxisObj.name = yAxisObj.name ? this.$t(yAxisObj.name) : "";
        });
      });

      return yAxis;
    },
    metric() {
      return this.instantaneousValue.map((item) => ({
        name: this.extractName(item.name),
        value: this.extractValue(item.name, item.value),
      }));
    },
    widgetData() {
      const tempObj = {};
      this.widgetList.forEach((item) => {
          if (typeof item.value === 'string' && item.value.includes(':')) {
          tempObj[item.name] = item.value;
        } else {
          tempObj[item.name] =
            item.value && item.value !== null && item.value !== "No Data"
              ? parseFloat(item.value).toFixed(2)
              : 0;
        }

        if (item.name === 'Grid Availability') {
          tempObj['value_generation'] = (item.value_generation !== undefined && item.value_generation !== null)
            ? parseFloat(item.value_generation).toFixed(2) : 0;
          tempObj['value_non_generation'] = (item.value_non_generation !== undefined && item.value_non_generation !== null)
            ? parseFloat(item.value_non_generation).toFixed(2) : 0;
        }
      });
      return tempObj;
    },
    carbonFootprint() {
      const co2EmissionLifeTime =
        ((this.lifeTimeGeneration || 0) * this.co2Multiplier) / 1000;
      const treeSapling = this.lifeTimeGeneration * this.equiTreesMultiplier;
      const countCo2Decimal =
        this.countIntegersBeforeDecimal(co2EmissionLifeTime);
      const co2ComputedLifeTime = this.convertUnit(
        co2EmissionLifeTime,
        countCo2Decimal,
        "Tons"
      );
      const countTreeSaplingDecimal =
        this.countIntegersBeforeDecimal(treeSapling);
      const treeSaplingComputedLifeTime = this.convertToPower(
        treeSapling,
        countTreeSaplingDecimal
      );

      // TODAY's
      const co2EmissionToday = this.todayco2Reduction;
      const treeSaplingToday = this.todayco2Reduction * 29.8469;
      const countCo2TodayDecimal =
        this.countIntegersBeforeDecimal(co2EmissionToday);
      const co2ComputedToday = this.convertUnit(
        co2EmissionToday,
        countCo2TodayDecimal,
        "Tons"
      );
      const countTreeSaplingTodayDecimal =
        this.countIntegersBeforeDecimal(treeSaplingToday);
      const treeSaplingComputedToday = this.convertToPower(
        treeSaplingToday,
        countTreeSaplingTodayDecimal
      );

      return {
        emission: {
          today: {
            data: this.todayco2Reduction
              ? co2ComputedToday.value.toFixed(2)
              : "-",
            unit: "Tons",
          },
          lifetime: {
            data: this.lifeTimeGeneration
              ? co2ComputedLifeTime.value.toFixed(2)
              : "-",
            unit: co2ComputedLifeTime.unit,
          },
        },
        sapling: {
          today: {
            data: this.todayco2Reduction ? treeSaplingComputedToday : "-",
            unit: "Nos",
          },
          lifetime: {
            data: this.lifeTimeGeneration ? treeSaplingComputedLifeTime : "-",
            unit: "Nos",
          },
        },
      };
    },
    selectedTabCompPosition() {
      const defaultPosition = {
        pos_1: "table",
        pos_2: "other_cards",
        pos_3: "graph_left",
        pos_4: "graph_right",
        pos_21: "availability",
        pos_22: "carbon_footprint",
        pos_23: "card_left",
        pos_24: "card_right",
      };
      if (_.isEmpty(this.positions)) {
        return defaultPosition;
      }
      if (this.selectedTab == "plant") {
        if (this.positions.plant && !_.isEmpty(this.positions.plant)) {
          return this.positions["plant"];
        }
      } else {
        if (
          this.positions.block &&
          !_.isEmpty(this.positions.block) &&
          this.positions.block[`id_${this.blockId}`] &&
          !_.isEmpty(this.positions.block[`id_${this.blockId}`])
        ) {
          return this.positions.block[`id_${this.blockId}`];
        }
      }
      return defaultPosition;
    },
  },
  async mounted() {
    await this.getBlockList();
    await this.getCompPositions();
    this.getWidgetDataHandler();
    this.setIntervalWithoutDelay(this.callAllApi);
  },
  methods: {
    ...mapMutations(["SET_LAST_CALL_TIME", "SET_PROGRESS_BAR"]),
    initializeData() {
      this.widgetDataSet = [];
      this.showMap = false;
      this.showStaticInfo = false;
      this.tableData = [];
      this.todayco2Reduction = 0;
      this.co2Multiplier = 0.392;
      this.equiTreesMultiplier = 0.0117;
      this.cardDataSetLeft = [];
      this.cardDataSetRight = [];
      this.lifeTimeGeneration = 0;
    },
    closeDialogHandler() {
      document.querySelector(".overlay").style.display = "none";
      this.showMap = false;
      this.showStaticInfo = false;
    },
    async getCompPositions() {
      const res = await PlantOverviewAPI.getCompPostions(
        this.getSelectedPlantId
      );
      this.positions = res.data.message.component;
      const stringToJson = JSON.parse(res.data.message.carbonFootprint)
      this.co2Multiplier = stringToJson
        && stringToJson.co2_multiplier 
          ? stringToJson.co2_multiplier : 0.392;
      this.equiTreesMultiplier = stringToJson && 
        stringToJson.equi_trees_multiplier 
          ? stringToJson.equi_trees_multiplier : 0.0117;
    },
    callAllApi() {
      this.SET_PROGRESS_BAR(true);
      let updateTime = moment().format("MM-DD-YYYY H:mm:ss");
      this.SET_LAST_CALL_TIME(updateTime);
      let responseList = [];
      responseList.push(this.getWidgetData());
      responseList.push(this.getGraphData());
      if (this.selectedTab === "plant") {
        responseList.push(this.getPlantLevelData());
      } else {
        this.initializeData();
        responseList.push(this.getBlockLevelData());
      }

      Promise.all(responseList)
        .then((res) => {
          this.SET_PROGRESS_BAR(false);
        })
        .catch((err) => {
          console.log(err, "ERROR");
          this.SET_PROGRESS_BAR(false);
        });
    },
    floatMenuSelectHandler(selection) {
      if (selection.component === "map") {
        this.showMap = true;
        document.querySelector(".overlay").style.display = "block";
      } else if (selection.component === "static") {
        this.showStaticInfo = true;
        document.querySelector(".overlay").style.display = "block";
      } else if (selection.component === "document") {
        const path = selection.path;
        if (path.includes('amazonaws.com')) {
          const protocol = window.location.protocol;
          const baseUrl = process.env.VUE_APP_BASE_URL || (`${protocol}//${window.location.hostname}:3030`);
          const encodedUrl = encodeURIComponent(path);
          window.open(`${baseUrl}/api/v2/assets?url=${encodedUrl}`, "_blank");
        } else {
          window.open(path);
        }
      } else {
        this.$router.push(selection.path);
      }
    },
    tabChange(item) {
      if (item.id === "plant") {
        this.selectedTab = "plant";
      } else {
        this.selectedTab = "block";
        this.blockId = item.id;
      }
      this.setIntervalWithoutDelay(this.callAllApi);
    },
    async getBlockList() {
      let response = await CommonApi.getBlockList(this.getSelectedPlantId);
      this.blockList = response.data.message;

      if (this.blockList.length === 1) {
        this.blockList = [
          {
            id: "plant",
            text: "Plant Details",
          },
        ];
      } else {
        this.blockList.unshift({
          id: "plant",
          text: "Plant Details",
        });
      }
    },
    async getPlantLevelData() {
      await this.getCardData();
      await this.getKpiData();
    },
    async getBlockLevelData() {
      await this.getBlockCardData();
      await this.getBlockKpiData();
    },
    async getGraphData() {
      const response = await PlantOverviewAPI.getGraphPlant(
        this.getSelectedPlantId,
        momentTz().tz(this.getActivePlantTimezone).format("X"),
        momentTz().tz(this.getActivePlantTimezone).format("X")
      );

      const positionList = ["left", "right"];
      for (let position of positionList) {
        const tempData = {};
        let xAxisData = [];
        let data = {};

        Object.keys(response.data.message[position].data).forEach(
          (deviceName, index) => {
            if (
              deviceName == "weather station" &&
              Object.keys(response.data.message[position].data).length > 1
            ) {
              this.yAxis[position][0].name = "Other Parameters";
              this.yAxis[position].push({
                type: "value",
                name: "WS Parameters",
                min: 0,
                position: "right",
                axisLabel: {
                  formatter: "{value}",
                  rotate: 40,
                },
              });
            } else {
              this.yAxis[position][0].name = "WS Parameters";
            }
            Object.keys(
              response.data.message[position].data[deviceName]
            ).forEach((parameter, i) => {
              response.data.message[position].data[deviceName][
                parameter
              ].forEach((el) => {
                if (!data[parameter]) {
                  data[parameter] = {
                    device: deviceName,
                    data: [],
                  };
                }
                data[parameter].data.push(el[parameter]);
                if (index == 0 && i == 0) {
                  xAxisData.push(el["Sensor Time"]);
                }
              });
            });
          }
        );

        response.data.message[position].headers.forEach((el) => {
          if (el.text != "Sensor Time") {
            tempData[el.text] = {
              name: `${el.text} ${el.unit ? `(${el.unit})` : ""}`,
              type: "line",
              device: el.deviceName,
              parameterName: el.name,
              large: true,
              data: data[el.text].data,
            };
            if (data[el.text].device == "weather station") {
              tempData[el.text]["yAxisIndex"] = 1;
            }
          }
        });
        const graphName = response.data.message[position].graphName;
        this[position] = {
          isMap: false,
          title: graphName.toUpperCase(),
        };
        this.xAxisData[position] = xAxisData;
        this.series[position] = Object.values(tempData);
      }
    },
    async getWidgetData() {
      this.widgetDataSet = []; // Clear existing data to ensure removed widgets disappear immediately
      const response = await PlantOverviewAPI.getWidgetPlant(
        this.getSelectedPlantId,
        momentTz().tz(this.getActivePlantTimezone).format("X"),
        momentTz().tz(this.getActivePlantTimezone).format("X")
      );
      this.widgetDataSet = response.data.message;
      this.getWidgetDataHandler(); 
    },
    async getKpiData() {
      const response = await PlantOverviewAPI.getKpiPlant(
        this.getSelectedPlantId,
        momentTz().tz(this.getActivePlantTimezone).format("X")
      );
      const tempArr = [];
      response.data.message.parameter.forEach((param) => {
        const obj = {
          name: param.name,
          unit: param.unit,
        };
        Object.keys(response.data.message.data).forEach((el) => {
          obj[el] = response.data.message.data[el][param.parameter];
        });
        tempArr.push(obj);
      });
      this.tableData = tempArr;
      const co2ParamObj = response.data.message.parameter.filter(
        (el) => el.parameter == "co2_reduction"
      );
      let factor = 1;
      if (co2ParamObj.length > 0 && co2ParamObj[0].unit == "MWh") {
        factor = 1000;
      }
      this.todayco2Reduction =
        parseFloat(response.data.message.data.today.co2_reduction) * factor;
    },
    async getBlockKpiData() {
      const response = await PlantOverviewAPI.getKpiBlock(
        this.getSelectedPlantId,
        this.blockId,
        momentTz().tz(this.getActivePlantTimezone).format("X")
      );
      const tempArr = [];
      response.data.message.parameter.forEach((param) => {
        const obj = {
          name: param.name,
          unit: param.unit,
        };
        Object.keys(response.data.message.data).forEach((el) => {
          obj[el] = response.data.message.data[el][param.parameter];
        });
        tempArr.push(obj);
      });
      this.tableData = tempArr;
      const co2ParamObj = response.data.message.parameter.filter(
        (el) => el.parameter == "co2_reduction"
      );
      let factor = 1;
      if (co2ParamObj.length > 0 && co2ParamObj[0].unit == "MWh") {
        factor = 1000;
      }
      this.todayco2Reduction =
        parseFloat(response.data.message.data.today.co2_reduction) * factor;
    },
    async getCardData() {
      const response = await PlantOverviewAPI.getCardPlant(
        this.getSelectedPlantId,
        momentTz("05:00:00", "HH:mm:ss")
          .tz(this.getActivePlantTimezone)
          .format("X"),
        momentTz().tz(this.getActivePlantTimezone).format("X")
      );
      const lifeTimeObj = response.data.message.sourceData;
      this.lifeTimeGeneration =
        lifeTimeObj.value * this.calcUnit(lifeTimeObj.unit);
      const tempArr = response.data.message.data
      .map((el) => {
        if (el.value == null) {
          el.value = "-";
        }
        return el;
      });

      let leftCount = tempArr.length - this.findLowerEvenHalf(tempArr.length);
      this.cardDataSetLeft = tempArr.slice(0, leftCount);
      this.cardDataSetRight = tempArr.slice(leftCount, tempArr.length);
    },
    findLowerEvenHalf(n) {
      const nxtNum = n + 1;
      if ((nxtNum / 2) % 2 === 0) {
        return Math.floor(n / 2);
      }
      const half = n / 2;
      const roundedHalf = Math.floor(half);

      if (roundedHalf % 2 === 0) {
        return roundedHalf;
      } else {
        return roundedHalf - 1;
      }
    },
    getBlockCardData() {
      PlantOverviewAPI.getCardBlock(
        this.getSelectedPlantId,
        this.blockId,
        momentTz("05:00:00", "HH:mm:ss")
          .tz(this.getActivePlantTimezone)
          .format("X"),
        momentTz().tz(this.getActivePlantTimezone).format("X")
      ).then((response) => {
        const lifeTimeObj = response.data.message.sourceData;
        this.lifeTimeGeneration =
          lifeTimeObj.value * this.calcUnit(lifeTimeObj.unit);
        const tempArr = response.data.message.data
        .map((el) => {
          if (el.value == null) {
            el.value = "-";
          }
          return el;
        });

        const leftCount = tempArr.length - this.findLowerEvenHalf(tempArr.length);
        this.cardDataSetLeft = tempArr.slice(0, leftCount);
        this.cardDataSetRight = tempArr.slice(leftCount, tempArr.length);
      });
    },
    calcUnit(unit) {
      switch (unit) {
        case "kWh":
          return 1;
        case "MWh":
          return 1000;
        case "GWh":
          return 1000000;
      }
    },
    getWidgetDataHandler() {
      this.widgetList = [];
      this.instantaneousValue = [];
      this.widgetDataSet.forEach((el) => {
        if (
          el.name === "Plant Availability" ||
          (el.name && el.name.startsWith("Grid Availability"))
        ) {
          this.widgetList.push(el);
          return;
        }
        this.instantaneousValue.push(el);
      });
    },
    countIntegersBeforeDecimal(number) {
      const stringRepresentation = number.toString();
      const indexOfDecimal = stringRepresentation.indexOf(".");

      if (indexOfDecimal !== -1) {
        return indexOfDecimal;
      } else {
        return stringRepresentation.length;
      }
    },
    extractName(name) {
      switch (name) {
        case "Instant Grid Availability":
          return this.$t("Grid Status");
        case "Instantaneous Plant Availability":
          return this.$t("Inst. PA (%)");
        case "Plant Down Time":
        case "Total Grid Down Time":
        case "Plant Start":
        case "Plant Stop":
          return this.$t(name) + " (HH:mm)";
        default: {
          return this.$t(name);
        }
      }
    },
    extractValue(name, value) {
      switch (name) {
        case "Grid Status":
        case "Instant Grid Availability":
          if (value === true) {
            return "Up";
          } else if (value === false) {
            return "Down";
          } else {
            return "-";
          }
        default: {
          return value === "-" || !isNaN(parseFloat(value)) ? value : "-";
        }
      }
    },
    convertUnit(value, decimalCount, unit) {
      let computedUnit = "";
      if (decimalCount >= 4 && decimalCount < 6) {
        value = value / 1000;
        computedUnit = "k";
      }

      if (decimalCount >= 6 && decimalCount < 8) {
        value = value / 1000000;
        computedUnit = "M";
      }

      if (decimalCount >= 8) {
        value = value / 1000000000;
        computedUnit = "G";
      }

      computedUnit = computedUnit == "" ? unit : `${computedUnit}${unit}`;
      return {
        value: value,
        unit: computedUnit,
      };
    },
    convertToPower(value, decimalCount) {
      if (decimalCount >= 4) {
        const numbersBeforeDecimal = decimalCount - 2;
        return `${(value / Math.pow(10, numbersBeforeDecimal)).toFixed(
          0
        )} * 10 ^${numbersBeforeDecimal}`;
      } else {
        return value.toFixed(0);
      }
    },
  },
  watch: {
    async getSelectedPlantId() {
      this.initializeData();
      this.selectedTab = "plant";
      this.blockId = 1;
      this.blockList = [];
      this.series = {
        left: [],
        right: [],
      };
      this.xAxisData = {
        left: [],
        right: [],
      };
      this.left = {
        isMap: false,
        title: "",
      };
      this.right = {
        isMap: false,
        title: "",
      };
      await this.getBlockList();
      await this.getCompPositions();
      this.setIntervalWithoutDelay(this.callAllApi);
    },
    isReload() {
      if (this.isReload) {
        this.setIntervalWithoutDelay(this.callAllApi);
      }
    },
    "$i18n.locale": {
      handler() {
        this.componentKey++;
      },
    },
    widgetDataSet() {
      this.getWidgetDataHandler();
    },
  },
};
</script>

<style>
/* Global Styles */
.table-card {
  height: 100%;
  border-radius: 8px;
  box-shadow: 0px 5px 5px 0px #334079;
}
</style>

<style scoped >

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: none;
  z-index: 2;
  cursor: pointer;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.graph {
  width: 100%;
  height: 370px;
  /* height: 100%; */
}

.activeTab:hover {
  background-color: var(--v-sixth-base);
}

.note {
  margin: auto;
  color: #fbbc05;
}

.unit {
  color: #aeaeae;
}

.value {
  font-size: 14px;
  font-weight: 600;
}

.no-value {
  font-size: 14px;
  font-weight: 600;
}

.map-card {
  height: 100%;
  border: 1px solid #334079 !important;
  border-radius: 8px;
  box-shadow: 0px 5px 5px 0px #334079;
}

.custom-divider {
  background-color: #334079;
}

.card-height-250 {
  min-height: 257px;
  max-height: 257px;
  overflow-y: auto;
}

.card-title {
  font-size: 15px;
  text-align: center;
  padding: 10px 0 4px 0;
  margin-bottom: 5px;
}

@media (max-width: 960px) {
  .v-flex {
    flex-basis: 100% !important;
    width: 100% !important;
  }
  .full{
    padding-bottom: 70px !important;
  }
  .note {
    text-align: center;
  }
}

@media (max-width: 600px) {
  .graph {
    height: 250px;
  }

  .card-title {
    font-size: 12px;
  }
  .value,
  .no-value {
    font-size: 12px;
  }
}
</style>